import httpCommon from "./http-common";

// Get all document types
const getDocumentTypes = () => {
  return httpCommon.get("/v1/get/documentType");
};

// Create new document type
const createDocumentType = (data: any) => {
  return httpCommon.post("/v1/add/documentType", data);
};

// Update document type
const updateDocumentType = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/documentType/${id}`, data);
};

// Delete document type
const deleteDocumentType = (id: number) => {
  return httpCommon.delete(`/v1/delete/documentType/${id}`);
};

// Get document type by ID
const getDocumentTypeById = (id: number) => {
  return httpCommon.get(`/v1/get/documentType/${id}`);
};

const DocumentTypesService = {
  getDocumentTypes,
  createDocumentType,
  updateDocumentType,
  deleteDocumentType,
  getDocumentTypeById,
};

export default DocumentTypesService; 